import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Mail } from "react-feather";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Input, Label, Media } from "reactstrap";
import SweetAlert from "sweetalert2";
import BecomeTutorContext from "../../../_helper/BecomeTutor";
import FilterContext from "../../../_helper/Filter";
import { userLoggedOut } from "../../../redux/features/auth/authSlice";
import { clearMemberMenus } from "../../../redux/features/menus/menuSlice";
import { useWindowWidth } from "../../Chat/NewChat/inbox/useWindowWidth";
import NavbarContain from "./ChildComponent/Navbar";
import BecomeTutorCreateAccount from "./S1.CreateAccount";
import NewBecomeTutorSubjects from "./S2.NewSubjectsPricing.jsx";
import S3 from "./S3";
import BecomeTutorPersonal from "./S4.Personal";
import BecomeTutorAddress from "./S5.Address";
import NewBecomeTutorEducation from "./S6.NewEducation";
import NewBecomeTutorExperience from "./S7.NewExperience";
import PhotoUpload from "./S8.Photo";
import "./become-tutor.css";
import { getResendEmailResponse } from "./fnBecomeTutor";
import { fnResendEmail } from "../../../Services/Filter.Service";

const BecomeTutorContain = () => {
  const _tuteair = JSON.parse(localStorage.getItem("_tuteair_newTutor"));
  const [seconds, setSeconds] = useState(59);
  const [resendEnabled, setResendEnabled] = useState(false);
  const [minutes, setMinutes] = useState(0);

  const {
    step,
    setStep,
    getLoggedTutorInfo,
    clearBecomeTutorContext,
    isEmailVerified,
    setIsEmailVerified,
    becomeTutorCreateAccountResponsiveness,
  } = useContext(BecomeTutorContext);

  const { accountType, isTutor, setIsTutor } = useContext(FilterContext);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const width = useWindowWidth();

  useEffect(() => {
    document.title = "Become a Tutor | TuteAir - Learn & Teach Globally";
    setIsTutor(false);
    if (_tuteair?.accessToken && _tuteair?._id) {
      if (_tuteair.accountType === "student") {
        navigate(`${process.env.PUBLIC_URL}/become-student`);
      } else {
        getLoggedTutorInfo(_tuteair?._id);
        setStep(_tuteair.currentStep);
      }
    } else {
      dispatch(userLoggedOut());
      dispatch(clearMemberMenus());
      clearBecomeTutorContext();
      localStorage.clear();
      navigate(`${process.env.PUBLIC_URL}/become-tutor`);
    }
  }, []);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
        if (_tuteair?.currentStep > 0 && !_tuteair?.emailVerified) {
          setResendEnabled(true);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const handleResendEmail = async () => {
    // var response = await getResendEmailResponse(_tuteair?._id);
    // setResendEnabled(false);
    // if (response?.message === "verified") {
    //   setIsEmailVerified(true);
    //   SweetAlert.fire({
    //     title: `Your email are already verified.`,
    //     text: "Thank you for being with TuteAir. Complete your profile to find your desired tuitions.",
    //   });
    // } else if (response?.message === "success") {
    //   SweetAlert.fire({
    //     title: `Email sent to <u>${_tuteair?.email}<u/>`,
    //     text: "N.B: If you do not see the email in a few minutes, check your “junk mail” folder or “spam” folder",
    //   });
    // }
    await fnResendEmail({ setResendEnabled, setIsEmailVerified });
  };

  const handleNotReceivedEmail = async (e) => {
    e.preventDefault();
    var htmlText = "";
    htmlText +=
      "<p>If you do not see the email in your inbox in a few minutes, please check your junk mail folder and add  <q>support@tuteair.com</q> to your White List or Safe Sender List.</p>";
    htmlText +=
      "<p>We make every effort to ensure that these emails are delivered.</p>";
    htmlText += `<p>If you still don’t receive an email, then please click on <b>Resend Email</b></p>`;

    SweetAlert.fire({
      allowOutsideClick: false,
      allowEscapeKey: false,
      backdrop: true,
      title: "Didn't receive an Email?",
      html: htmlText,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Ok",
      confirmButtonColor: "#27a75d",
      cancelButtonText: "Resend Email",
      cancelButtonColor: "#3a8ec5",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        //SweetAlert.fire("Deleted!", "Your file has been deleted.", "success");
      } else {
        handleResendEmail();
      }
    });
  };

  const switchMemberToggle = (isTutor) => {
    setIsTutor(!isTutor);
    if (isTutor) {
      navigate(`${process.env.PUBLIC_URL}/become-tutor`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/become-student`);
    }
  };

  const accountType2 = JSON.parse(
    localStorage.getItem("_tuteair_newTutor")
  )?.accountType;

  // routing to become member as this page is not being used 
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_NEXT_ROUTE}/become-member/about-me`
  }, []);

  return (
    <></>
    // <>
    //   <div className="" style={{ background: "#f0f8ffd9" }}>
    //     <NavbarContain />
    //     <section
    //       className={` ${
    //         becomeTutorCreateAccountResponsiveness === true && width < 576
    //           ? ""
    //           : "container py-1 mt-5 py-md-5"
    //       } ${step !== 0 ? "container_padding" : ""}`}
    //     >
    //       {step > 0 && (
    //         <Row className="mt-4" style={{ placeContent: "center" }}>
    //           <Col className="email_confirm_title text-center">
    //             {!isEmailVerified && (
    //               <div className="w-100 d-flex justify-content-center align-items-center flex-column flex-md-row">
    //                 <div className="d-flex">
    //                   <Mail width={17} height={17} />
    //                   <h5 className="px-2 d-none d-md-block">
    //                     An Email has been sent to your email. Please confirm
    //                     your email.
    //                   </h5>
    //                   <small className="fw-bold fs-6 d-md-none px-1">
    //                     {" "}
    //                     An Email has been sent to your email. <br /> Please
    //                     confirm your email.
    //                   </small>
    //                 </div>

    //                 <a
    //                   href="#resentEmail"
    //                   onClick={(e) => handleNotReceivedEmail(e)}
    //                   className="text-underline px-3"
    //                 >
    //                   Didn't receive an Email?
    //                 </a>
    //                 {/* <button
    //                   className="btn btn-sm py-1 text-dark btn-light-gradien mx-3"
    //                   // disabled={!resendEnabled}
    //                   disabled={false}
    //                   onClick={(e) => handleResendEmail(e)}
    //                 >
    //                   Resend
    //                   {minutes === 0 && seconds === 0 ? null : (
    //                     <span>
    //                       {" "}
    //                       in {seconds < 10 ? `0${seconds}` : seconds}
    //                     </span>
    //                   )}
    //                 </button> */}
    //               </div>
    //             )}
    //           </Col>
    //         </Row>
    //       )}

    //       {(accountType === "both" || accountType2 === "both") && step > 0 && (
    //         <hr className="my-1 d-md-none border border-primary" />
    //       )}

    //       {(accountType === "both" || accountType2 === "both") && step > 0 && (
    //         <div className="d-flex mt-2 mt-md-4 justify-content-center align-items-center flex-column flex-md-row">
    //           <h5 className="pe-3 d-none d-md-block">
    //             Switch to 'Student' type to give required information:
    //           </h5>
    //           <small className="fw-bold mb-1 d-md-none">
    //             Switch to 'Student' type to give required information:
    //           </small>
    //           <div className="d-flex align-items-center">
    //             <h5 className="px-2"> Tutor </h5>
    //             <Media body className={"text-end switch-outline media-body"}>
    //               <Label className="switch p-0 m-0">
    //                 <Input
    //                   type="checkbox"
    //                   checked={isTutor}
    //                   onClick={(e) => switchMemberToggle(isTutor)}
    //                   onChange={(e) => switchMemberToggle(isTutor)}
    //                 />
    //                 <span
    //                   className="switch-state bg-primary"
    //                   style={{ background: "#6b6b91" }}
    //                 ></span>
    //               </Label>
    //             </Media>
    //             <h5 className="px-2"> Student </h5>
    //           </div>
    //         </div>
    //       )}

    //       {step === 0 ? (
    //         <BecomeTutorCreateAccount />
    //       ) : step === 1 ? (
    //         <BecomeTutorPersonal step={3} />
    //       ) : step === 2 ? (
    //         <NewBecomeTutorSubjects />
    //       ) : step === 3 ? (
    //         // <BecomeTutorSchedule />
    //         <S3></S3>
    //       ) : step === 4 ? (
    //         <BecomeTutorAddress step={4} />
    //       ) : step === 5 ? (
    //         <NewBecomeTutorEducation step={5} />
    //       ) : step === 6 ? (
    //         <NewBecomeTutorExperience />
    //       ) : step === 7 ? (
    //         <PhotoUpload step={7} />
    //       ) : (
    //         <NewBecomeTutorSubjects />
    //       )}
    //     </section>
    //   </div>
    // </>
  );
};

export default BecomeTutorContain;
